/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Prefs_Date_FormatInputs */

const cs_settings_prefs_date_format = /** @type {(inputs: Settings_Prefs_Date_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formát data`)
};

const en_settings_prefs_date_format = /** @type {(inputs: Settings_Prefs_Date_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date format`)
};

/**
* | output |
* | --- |
* | "Date format" |
*
* @param {Settings_Prefs_Date_FormatInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_prefs_date_format = /** @type {((inputs?: Settings_Prefs_Date_FormatInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Prefs_Date_FormatInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_prefs_date_format(inputs)
	return cs_settings_prefs_date_format(inputs)
});